<ng-container *ngIf="currentStep$ | async as currentStep">
  <app-send-confirmation *ngIf="currentStep === 1"></app-send-confirmation>
  <app-review-submit *ngIf="currentStep === 2"></app-review-submit>
  <app-confirmation *ngIf="currentStep === 3"></app-confirmation>
</ng-container>
